import { takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
  getInitiatedBookingsError,
  getInitiatedBookingsSuccessful,
  setInitiatedBookingQuery
} from "./actions";
import InitiatedBookingService from "./service";
import {InitiatedBookingActionTypes} from "./actionTypes";

// Selector to get the initiated booking query state from the Redux store.
export const getInitiatedBookingQuery = state => state.InitiatedBookings.query;

export function* get({payload}) {
  try {
    // Get the current query from the Redux store.
    const storedQuery = yield select(getInitiatedBookingQuery);
    // The payload from the action can override the stored query for this specific call.
    const finalPayload = { ...storedQuery, ...payload };
    const response = yield call(InitiatedBookingService.getInitiatedBookings, finalPayload);
    yield put(getInitiatedBookingsSuccessful(response));
    yield put(setInitiatedBookingQuery(finalPayload));
  } catch (error) {
    yield put(getInitiatedBookingsError(error));
  }
}

export function* watchGetInitiatedBooking() {
  yield takeLatest(InitiatedBookingActionTypes.INITIATED_BOOKING_LIST_GET, get);
}

function* initiatedBookingSaga() {
  yield all([
    fork(watchGetInitiatedBooking)
  ]);
}

export default initiatedBookingSaga;
